/* Justabox — theme behaviour (Dawn section package). Dependency-free. */
(function () {
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function pad(n){ return ('' + n).padStart(2, '0'); }

  ready(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- scroll reveals ---- */
    var reveals = [].slice.call(document.querySelectorAll('[data-jb-reveal]'));
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; });
    } else {
      reveals.forEach(function (el) { el.style.opacity = 0; el.style.transform = 'translateY(30px)'; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target, d = parseInt(el.getAttribute('data-jb-d') || '0', 10);
          el.style.transition = 'opacity 1s cubic-bezier(.16,1,.3,1) ' + d + 'ms, transform 1s cubic-bezier(.16,1,.3,1) ' + d + 'ms';
          el.style.opacity = 1; el.style.transform = 'none';
          el.querySelectorAll('[data-jb-countup]').forEach(countUp);
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ---- count-up ---- */
    function countUp(el) {
      if (el.__cu) return; el.__cu = true;
      var m = (el.textContent || '').trim().match(/^(\d+)(\D*)$/); if (!m) return;
      var target = parseInt(m[1], 10), suffix = m[2] || '';
      if (reduce || target === 0) { el.textContent = target + suffix; return; }
      var dur = 950, t0 = performance.now();
      (function step(){ var p = Math.min(1, (performance.now() - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * e) + suffix; if (p < 1) requestAnimationFrame(step); else el.textContent = target + suffix; })();
    }

    /* ---- next-game countdown (reads season game data on the page) ---- */
    var games = [].slice.call(document.querySelectorAll('[data-jb-game-date]')).map(function (g) {
      return { ts: new Date(g.getAttribute('data-jb-game-date')).getTime(), opp: g.getAttribute('data-jb-game-opp') || '' };
    }).filter(function (g) { return !isNaN(g.ts); }).sort(function (a, b) { return a.ts - b.ts; });
    function nextGame(){ var now = Date.now(), pick = null; games.forEach(function (g) { if (!pick && g.ts >= now) pick = g; }); return pick || games[games.length - 1]; }
    var cdEls = document.querySelectorAll('[data-jb-countdown]'), ngEls = document.querySelectorAll('[data-jb-nextgame]');
    if (cdEls.length && games.length) {
      (function tick(){ var g = nextGame(); if (!g) return; var ms = Math.max(0, g.ts - Date.now()), s = Math.floor(ms / 1000);
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
        cdEls.forEach(function (e) { e.textContent = d + ':' + pad(h) + ':' + pad(mi) + ':' + pad(se); });
        ngEls.forEach(function (e) { var px = e.getAttribute('data-jb-prefix') || ''; e.textContent = (px ? px + ' ' : '') + g.opp; });
        setTimeout(tick, 1000); })();
    }

    /* ---- scroll progress + marquee drift ---- */
    var prog = document.querySelector('[data-jb-progress]');
    var marquee = document.querySelector('[data-jb-marquee-outer]');
    function onScroll(){
      var sc = window.scrollY || window.pageYOffset, max = document.documentElement.scrollHeight - window.innerHeight, p = max > 0 ? sc / max : 0;
      if (prog) prog.style.width = (p * 100) + '%';
      if (marquee && !reduce) marquee.style.transform = 'translateX(' + (-p * 180).toFixed(1) + 'px)';
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    /* ---- mobile menu ---- */
    var burger = document.querySelector('[data-jb-burger]'), menu = document.querySelector('[data-jb-menu]');
    if (burger && menu) {
      function setMenu(open){ menu.setAttribute('data-open', open ? '1' : '0'); burger.setAttribute('data-open', open ? '1' : '0'); }
      burger.addEventListener('click', function () { setMenu(menu.getAttribute('data-open') !== '1'); });
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    }

    /* ---- enquiry modal ---- */
    var modal = document.querySelector('[data-jb-modal]');
    /* populate the Event dropdown from every enquire trigger on the page (games + event cards) */
    if (modal) {
      var sel = modal.querySelector('[name="contact[Event]"]');
      if (sel) {
        var seen = {}, otherOpt = sel.querySelector('option[data-jb-other]');
        document.querySelectorAll('[data-jb-enquire][data-jb-event]').forEach(function (el) {
          var v = el.getAttribute('data-jb-event');
          if (!v || seen[v]) return; seen[v] = 1;
          var o = document.createElement('option'); o.value = v; o.textContent = v;
          if (otherOpt) sel.insertBefore(o, otherOpt); else sel.appendChild(o);
        });
      }
    }
    function openModal(ev){
      if (!modal) return;
      if (ev) { var sel = modal.querySelector('[name="contact[Event]"]'); if (sel) { for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value === ev) { sel.value = ev; break; } } } }
      if (menu) menu.setAttribute('data-open', '0');
      modal.setAttribute('data-open', '1'); document.body.style.overflow = 'hidden';
    }
    function closeModal(){ if (!modal) return; modal.setAttribute('data-open', '0'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-jb-enquire]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(b.getAttribute('data-jb-event') || ''); }); });
    document.querySelectorAll('[data-jb-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
      /* reopen with success state after a successful Shopify form post */
      if (/[?&]contact_posted=true/.test(location.search)) {
        var body = modal.querySelector('[data-jb-formbody]'), ok = modal.querySelector('[data-jb-success]');
        if (ok) { if (body) body.style.display = 'none'; ok.style.display = 'flex'; openModal(); }
      }
    }
  });
})();
